export const FormTypeBilling = "billing";
export const FormTypeShipping = "shipping";

export const formFields = {
  first_name: "",
  last_name: "",
  address_one: "",
  address_two: "",
  city: "",
  state: "",
  zip_code: "",
  country: "",
  phone: "",
  email: "",
};

export const ecNextFormFields = {
  sfirst_name: "",
  slast_name: "",
  saddress_one: "",
  saddress_two: "",
  scity: "",
  sstate: "",
  szip_code: "",
  scountry: "",
  sphone: "",
  semail: "",
};